<template>
    <div class="text-center">
        <a :href="url" target="_blank" @click="trackEvent">
            <v-img :src="imageUrl" :alt="name" class="fl-promotion-image" />
        </a>
    </div>
</template>

<script lang="ts">
import { Vue } from 'vue-property-decorator';
import { analyticsTracker as flAnalyticsTracker } from '@findologic/js-common';
import { PropType } from 'vue';
import { EventNames } from '../../../Common/enums';
import flUtil from '../../../../../../shop-js/src/utils/utils.js';

export default Vue.extend({
    name: 'Promotion',
    props: {
        name: {
            type: String,
            required: true,
        },
        url: {
            type: String,
            required: true,
        },
        imageUrl: {
            type: String,
            required: true,
        },
        trigger: {
            type: Object,
            required: true,
        },
        analyticsTracker: {
            type: Object as PropType<flAnalyticsTracker>,
            required: true,
        },
    },
    methods: {
        trackEvent() {
            this.analyticsTracker.trackEvent(
                'findologicEvent',
                'FINDOLOGIC Click',
                'Promotion',
                this.name,
                () => {
                    flUtil.navigateTo(this.url);
                },
                { event: EventNames.PROMOTION_CLICK, ...this.trigger, promotion: this.name }
            );
        },
    },
});
</script>

<style scoped>
.fl-promotion-image {
    max-width: 100%;
    /* Shopware 5 forces img to be displayed as block. Fight that. */
    display: inline-block;
}
</style>
